import React from "react";
import { ThemeButtonBGPrimary } from "../Config";
import { useNavigate } from "react-router";
import { aiDetectorContext } from "./AIDetectorMain";
import { useContext } from "react";
import { countWords } from "../Utils";
import { ai_probability_color_values } from "../Config";

const DetectorResult = () => {
  //get ai detector values
  const { aiDetectorTextsValues, detectorResultSectionRef } =
    useContext(aiDetectorContext);

  const handleClickHumanizeTextButton = () => {
    navigate("/"); //Navigate to new route
  }; //handle button click

  const navigate = useNavigate(); //react router navigate

  return (
    <div
      className={`container text-center mt-5 ${
        aiDetectorTextsValues.isLoaded ? "" : "d-none"
      }`}
      ref={detectorResultSectionRef}
      id="ai_detector_result"
    >
      <div className="shadow p-4">
        {/*Not enough texts*/}
        <h5 className="text-danger mb-3">**Enter long texts for best result</h5>
        {/*Show gemerated by*/}
        <h3 className="text-dark mb-5">
          Your text is{" "}
          <span
            className={`fs-1 ${
              aiDetectorTextsValues.probability > 0.5
                ? "text-danger"
                : "text-success"
            }`}
          >
            {aiDetectorTextsValues.probability > 0.5
              ? (aiDetectorTextsValues.probability * 100).toFixed(2) + "%"
              : ((1 - aiDetectorTextsValues.probability) * 100).toFixed(2) +
                "%"}
          </span>{" "}
          {aiDetectorTextsValues.probability > 0.5
            ? "AI written"
            : "human written"}{" "}
        </h3>

        {/*Progress Bar*/}
        <div className="progress mx-5">
          <div
            className={`progress-bar progress-bar-striped progress-bar-animated ${
              aiDetectorTextsValues.probability > 0.5
                ? "bg-danger"
                : "bg-success"
            }`}
            role="progressbar"
            style={{
              width: `${
                aiDetectorTextsValues.probability > 0.5
                  ? aiDetectorTextsValues.probability * 100
                  : (1 - aiDetectorTextsValues.probability) * 100
              }%`,
            }}
            aria-valuenow={
              aiDetectorTextsValues.probability > 0.5
                ? aiDetectorTextsValues.probability * 100
                : (1 - aiDetectorTextsValues.probability) * 100
            }
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>

        {/*Text Original*/}
        <p className="lead mt-5 text-start">
          {renderResultTextsWithHighlights(
            aiDetectorTextsValues.detection_sentences
          )}
        </p>

        {/*Highlited text desc */}
        <h5 className="text-warning mt-5">
          Highlited texts are more likely AI generated. Modify those sentences
          for better result.

          <p className="lead text-muted mt-3 fs-6 text-center">Note: Our AI detector identifies text that may have been generated by artificial intelligence. Use your own judgment when interpreting the results, and never rely solely on AI detection to make decisions that could affect someone's academic or professional future.</p>
        </h5>

        {/*Word Count*/}
        <div className="row justify-content-between mt-5">
          <div className="col col-lg-3 text-muted text-start">
            <b>Words Count: {countWords(aiDetectorTextsValues.text)}</b>
            <br />
            <b>Character Count: {aiDetectorTextsValues.text.length}</b>
          </div>

          {/* Humanize Button */}
          <div className="col col-lg-3">
            <div className="text-end">
              <button
                className="btn btn-success p-3 fs-5"
                type="button"
                style={{ backgroundColor: ThemeButtonBGPrimary }}
                onClick={handleClickHumanizeTextButton}
              >
                <img
                  src="./images/ai_brush.png"
                  alt="Humanize Text"
                  className="img-fluid"
                  style={{
                    width: "2rem",
                    height: "2rem",
                    marginRight: "0.5rem",
                  }}
                />{" "}
                Humanize Text
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  //render result texts with highlights
  //darker color for more ai written
  //light color for more human written
  function renderResultTextsWithHighlights(sentences) {
    //return
    //loop
    return sentences.map((item, index) => {
      //check
      if (item.sentence.includes("\n")) {
        //return new lines
        return [
          Array.from(item.sentence).map((item, index) => <br key={index}></br>),
        ];
      } else {
        //return
        return (
          <span
            key={index}
            style={{
              backgroundColor:
                ai_probability_color_values[
                  Math.floor((1 - item.probability) * 10)
                ],
            }}
          >
            {index > 0 ? ` ${item.sentence}` : item.sentence}
          </span>
        );
      }
    });
  }
};

export default DetectorResult;
